import { createContext, useContext, useEffect, useState } from 'react';
import api from '../lib/api';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(() => {
    const raw = localStorage.getItem('aawta_user');
    return raw ? JSON.parse(raw) : null;
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem('aawta_token');
    if (!token) {
      setLoading(false);
      return;
    }
    api
      .get('/auth/me')
      .then((r) => {
        setUser(r.data);
        localStorage.setItem('aawta_user', JSON.stringify(r.data));
      })
      .catch(() => {
        localStorage.removeItem('aawta_token');
        localStorage.removeItem('aawta_user');
        setUser(null);
      })
      .finally(() => setLoading(false));
  }, []);

  const login = async (email, password, remember = false) => {
    const res = await api.post('/auth/login-v2', { email, password, remember });
    localStorage.setItem('aawta_token', res.data.access_token);
    localStorage.setItem('aawta_user', JSON.stringify(res.data.user));
    setUser(res.data.user);
    return res.data.user;
  };

  const setUserFromGoogle = (u) => setUser(u);

  const logout = () => {
    localStorage.removeItem('aawta_token');
    localStorage.removeItem('aawta_user');
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, loading, login, logout, setUserFromGoogle, isAdmin: user?.role === 'leadership' || user?.role === 'director' }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
